import type { ReactNode } from 'react';
import React, { Fragment } from 'react';
import type { ModalProps } from 'Components/frameworks/modal/Modal';
import { Modal } from 'Components/frameworks/modal/Modal';
import { Toggler } from 'Components/frameworks/toggler/Toggler';
import type { TrackingPayload } from 'Tracking/tracking-api/useTracking';
import { useTracking } from 'Tracking/tracking-api/useTracking';
type Props = {
  children?: ReactNode;
  isExpanded?: boolean;
  modalProps?: ModalProps;
  renderTrigger: (handler: () => void, isExpanded: boolean) => ReactNode;
  trackingData?: TrackingPayload;
};
export const Tooltip = ({
  children,
  isExpanded,
  modalProps,
  renderTrigger,
  trackingData,
}: Props) => {
  const track = useTracking(trackingData);
  return (
    <Toggler
      isActive={isExpanded}
      onToggle={(isActive) => {
        if (trackingData && isActive) {
          track();
        }
      }}
    >
      {(toggle, isActive) => (
        <Fragment>
          {renderTrigger(toggle, isActive)}
          {isActive && (
            <Modal {...modalProps} onClose={toggle}>
              {children}
            </Modal>
          )}
        </Fragment>
      )}
    </Toggler>
  );
};
